import React from 'react';
import { XIcon, CheckIcon, LayoutGridIcon, GitBranchIcon, NetworkIcon } from 'lucide-react';
interface PropositionCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  crossed?: boolean;
  highlighted?: boolean;
}
function PropositionCard({
  icon,
  title,
  description,
  crossed,
  highlighted
}: PropositionCardProps) {
  return <div className={`
        relative p-8 rounded-2xl border transition-all duration-300 overflow-visible
        ${highlighted ? 'bg-surface-700 border-primary-500/50 shadow-lg shadow-primary-500/10' : 'bg-surface-800 border-surface-600 opacity-60'}
      `}>
      {crossed && <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <XIcon className="w-32 h-32 text-danger-500/20" strokeWidth={1} />
        </div>}
      <div className={`relative ${crossed ? 'opacity-50' : ''}`}>
        <div className={`
          w-14 h-14 rounded-xl flex items-center justify-center mb-6
          ${highlighted ? 'bg-primary-500/20 text-primary-400' : 'bg-surface-700 text-gray-400'}
        `}>
          {icon}
        </div>
        <h3 className={`text-xl font-semibold mb-3 ${crossed ? 'line-through text-gray-500' : 'text-white'}`}>
          {title}
        </h3>
        <p className="text-gray-400 leading-relaxed">{description}</p>
      </div>
      {highlighted && <div className="absolute -top-3 -right-3 z-10">
          <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center shadow-lg shadow-primary-500/50">
            <CheckIcon className="w-5 h-5 text-white" />
          </div>
        </div>}
    </div>;
}
export function ValueProposition() {
  return <section className="py-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Work is a graph.
            <br />
            <span className="text-gradient">
              Finally, there's a tool that sees it that way.
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Stop forcing your complex, interconnected work into linear lists and
            rigid workflows.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 pt-4 overflow-visible">
          <PropositionCard icon={<LayoutGridIcon className="w-7 h-7" />} title="Not another task list" description="Kanban boards and to-do lists can't capture dependencies, parallel work, or the true shape of complex projects." crossed />
          <PropositionCard icon={<GitBranchIcon className="w-7 h-7" />} title="Not a rigid workflow" description="Traditional flowcharts break when reality changes. Work isn't a straight line—it branches, pivots, and evolves." crossed />
          <PropositionCard icon={<NetworkIcon className="w-7 h-7" />} title="A living execution graph" description="StreamGraph adapts as you work. Tasks flow in parallel, agents execute autonomously, and the graph evolves with your project." highlighted />
        </div>
      </div>
    </section>;
}